export default __webpack_public_path__ + "static/media/Landing3.e19c7c2f.png";